module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/020-iraq-fb8d3c1c05a5f7a982f11e772ec2bd10.svg";